import translations from '@/data/loadoutTranslations.json'

function localeKey (locale) {
  return String(locale || 'en').split('-')[0].toLowerCase()
}

function localeData (locale) {
  return translations.locales[localeKey(locale)] || null
}

export function localizedEntryName (entry, type, locale) {
  if (!entry) return ''
  const data = localeData(locale)
  if (!data) return entry.displayName || entry.name
  const section = type === 'item'
    ? data.items
    : type === 'offering'
      ? data.offerings
      : type === 'perk' ? data.perks : data.addons
  const entryId = type === 'perk' ? (entry.wikiId || entry.id) : entry.id
  return (section && section[entryId]) || entry.displayName || entry.name
}

export function localizedCharacter (character, side, locale) {
  if (!character) return { name: '', displayName: '', realName: '', power: '' }
  const data = localeData(locale)
  const translated = data && data.characters && data.characters[side] && data.characters[side][String(character.id)]
  if (translated) {
    return {
      name: translated.name || character.name,
      displayName: translated.displayName || translated.name || character.name,
      realName: translated.realName || character.realName || '',
      power: translated.power || character.power || ''
    }
  }
  return {
    name: character.name,
    displayName: side === 'killer' && localeKey(locale) === 'en' ? `The ${character.name}` : character.name,
    realName: character.realName || '',
    power: character.power || ''
  }
}
